<template>
  <div>
    <el-card>
      <el-table :data="list" border>
        <el-table-column prop="patname" label="患者姓名"></el-table-column>
        <el-table-column prop="deptname" label="挂号科室"></el-table-column>
        <el-table-column prop="docname" label="挂号医生"></el-table-column>
        <el-table-column prop="numdate" label="号源日期"></el-table-column>
        <el-table-column prop="numtime" label="号源时间"></el-table-column>
        <el-table-column prop="regfee" label="挂号费"></el-table-column>
        <el-table-column label="详情" width="300">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="small"
              @click.prevent="getDetails(scope.row)"
              >处方
            </el-button>
            <el-button
              type="primary"
              size="small"
              @click.prevent="medical(scope.row)"
              >病历
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-row
        class="pagination-wrapper"
        type="flex"
        justify="end"
        style="margin-top: 30px"
      >
        <el-pagination
          layout="total,sizes,prev, pager, next"
          @size-change="handleSizeChange"
          :current-page.sync="page.pageNum"
          @current-change="onCurrentChange"
          :page-sizes="[10, 20, 50, 100]"
          :total="page.total"
        ></el-pagination>
      </el-row>
    </el-card>
  </div>
</template>
<script>
import axiosUtil from "../../utils/AxiosUtils.js";
import { tokenCache } from "../../../cache/tokenCache";
export default {
  data() {
    return {
      page: {
        pageNum: 1,
        pageSize: 10,
        pages: 1,
        total: 0,
      },
      checkedStatus: "1",
      states: [
        {
          label: 1,
          text: "病历",
        },
        {
          label: 2,
          text: "处方",
        },
      ],
      list: [],
      url: "",
      onlineOutpatientList: [],
      defaultProps: {
        label: "title",
        children: "list",
      },
    };
  },
  created: function () {},
  mounted: function () {
    this.initData();
  },
  methods: {
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.initData();
    },
    onCurrentChange(pageNum) {
      this.page.pageNum = pageNum;
      this.initData();
    },
    medical(item) {
      if(item.visitid==''){
        this.$message.error("没有就诊不可查看病历");
        return
      }
      this.$router.push({
        path: "/main/medicalList",
        query: { id: item.visitid },
      });
    },
    getDetails(item) {
      this.$store.state.prescription = item;
      this.$router.push({ path: "/main/prescriptionDetails" });
    },
    initData() {
      let that = this;
      axiosUtil(
        {
          hosid: that.hosId,
          patientid: JSON.parse(localStorage.getItem("userobj")).hosPatid,
          service: "smarthos.yygh.patient.visit.record.list",
          pageNum: that.page.pageNum,
          pageSize: that.page.pageSize,
          token: tokenCache.get(),
        },
        ({ code, list, rowCount, msg }) => {
          if (code == "0") {
            that.list = list;
            that.page.total = rowCount;
          }
        }
      );
    },
    // initData() {
    //   let that = this;
    //   axiosUtil(
    //     {
    //       orgid: "1200000000",
    //       ddid: JSON.parse(localStorage.getItem("userobj")).ddid,
    //       service: "smarthos.yygh.ApiyGHpaymentService.prescription.record",
    //       token: tokenCache.get(),
    //     },
    //     ({ code, recipeList, msg }) => {
    //       if (code == "0") {
    //         that.list=recipeList;
    //       }
    //     }
    //   );
    // },
    // initData() {
    //   let that = this;
    //   axiosUtil(
    //     {
    //       // service: "smarthos.recipe.user.pat.visit.record.list",
    //       // compatId: that.userobj.visitid,
    //       service: "smarthos.user.book.case.history.list.his.system",
    //       commonPatIdcard: JSON.parse(localStorage.getItem("userobj")).zjhm,
    //       token: tokenCache.get(),
    //     },
    //     ({ code, obj, msg }) => {
    //       if (code == "0") {
    //         // for (let i in obj.onlineOutpatientList) {
    //         //   for (let j in obj.onlineOutpatientList[i]
    //         //     .userBookCaseHistoryList) {
    //         //     obj.onlineOutpatientList[i].userBookCaseHistoryList[j].title =
    //         //       "病历" +
    //         //       " " +
    //         //       obj.onlineOutpatientList[i].userBookCaseHistoryList[j]
    //         //         .bookOrderNumber;
    //         //   }
    //         //   for (let o in obj.onlineOutpatientList[i].recipeOrderList) {
    //         //     if (obj.onlineOutpatientList[i].recipeOrderList) {
    //         //       if (
    //         //         obj.onlineOutpatientList[i].recipeOrderList[o].orderType ==
    //         //         "WESTERN_RECIPE"
    //         //       ) {
    //         //         obj.onlineOutpatientList[i].recipeOrderList[o].orderType =
    //         //           "西药方";
    //         //       } else if (
    //         //         obj.onlineOutpatientList[i].recipeOrderList[o].orderType ==
    //         //         "CHINESE_RECIPE"
    //         //       ) {
    //         //         obj.onlineOutpatientList[i].recipeOrderList[o].orderType =
    //         //           "草药方";
    //         //       } else if (
    //         //         obj.onlineOutpatientList[i].recipeOrderList[o].orderType ==
    //         //         "PRESCRIPT_RECIPE"
    //         //       ) {
    //         //         obj.onlineOutpatientList[i].recipeOrderList[o].orderType =
    //         //           "成药方";
    //         //       }
    //         //       // console.log(obj.onlineOutpatientList[i].recipeOrderList[o]);
    //         //     }
    //         //     obj.onlineOutpatientList[i].recipeOrderList[o].title =
    //         //       obj.onlineOutpatientList[i].recipeOrderList[o].orderType +
    //         //       " " +
    //         //       obj.onlineOutpatientList[i].recipeOrderList[o].id;
    //         //     obj.onlineOutpatientList[i].recipeOrderList[o].list =
    //         //       obj.onlineOutpatientList[i].recipeOrderList[o];
    //         //       if(obj.onlineOutpatientList[i].recipeOrderList[o].recipePdfUrl){
    //         //         obj.onlineOutpatientList[i].recipeOrderList[o].docSignPdfAfter =obj.onlineOutpatientList[i].recipeOrderList[o].recipePdfUrl;
    //         //       }
    //         //   }
    //         // }
    //         // obj.onlineOutpatientList.map((item) => {
    //         //   // item.list.title="处方"
    //         //   item.title =item.commonPatName + " " + item.createTime+'@'+item.docName;
    //         //   item.list = [
    //         //     {
    //         //       id: 1,
    //         //       title: "病历",
    //         //       list: item.userBookCaseHistoryList,
    //         //     },
    //         //     {
    //         //       id: 2,
    //         //       title: "处方",
    //         //       list: item.recipeOrderList,
    //         //     },
    //         //   ];
    //         //   return item;
    //         // });
    //         // that.onlineOutpatientList = obj.onlineOutpatientList;
    //       }
    //     }
    //   );
    // },
  },
};
</script>
<style>
</style>
